"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tokens = {
    breakpoints: {
        medium: 576,
        large: 1024,
        huge: 1280,
    },
};
exports.default = tokens;
